import React from 'react';

export const TypingIndicator = (): React.ReactNode => {
    return (
        <div className="tw:flex tw:items-start">
            <div className="tw:flex tw:gap-1.5 tw:rounded-lg tw:bg-surface-container tw:px-3 tw:py-2.5 tw:text-type-secondary">
                {[0, 1, 2].map((i) => (
                    <span
                        key={i}
                        className="tw:block tw:h-2 tw:w-2 tw:rounded-full tw:bg-current"
                        style={{
                            animation: 'typing-dot 1.4s ease-in-out infinite',
                            animationDelay: `${i * 0.2}s`,
                        }}
                    />
                ))}
            </div>
        </div>
    );
};
